<div class="wrapper" [style.width.px]="width">
  <div class="dropdown">
    <input
      #input
      class="select-trigger"
      [ngModel]="displayText"
      (click)="open(dropdown, input)"
      readonly
    />
    <span
      (click)="open(dropdown, input); $event.stopPropagation()"
      class="caret"
    >
      <svg
        width="8"
        height="6"
        viewBox="0 0 8 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.0063 6C5.08847 6 8.54781 1.01102 7.92574 0.445018C7.30366 -0.120985 0.768385 -0.175077 0.0868551 0.445018C-0.594674 1.0659 2.92498 6 4.0063 6Z"
          fill="#4D578D"
        />
      </svg>
    </span>
    <ng-template #dropdown>
      <div class="select-menu-wrapper">
        @for (option of options; track option) {
          <div
            class="select-menu-item"
            [class.active]="selected === option"
            (click)="select(option)"
          >
            <span>{{ option.label }}</span>
          </div>
        }
      </div>
    </ng-template>
  </div>
</div>
